/*
 *
 * Selectors for MyEGiftCards
 *
 */

import { createSelector } from 'reselect';
import { utils } from '../../devUtils';

const selectMyEGiftCardsDomain = (state) => state.get('myEGiftCards');
const selectMyEGiftCards = () => createSelector(
  selectMyEGiftCardsDomain,
  (MyEGiftCards) => MyEGiftCards,
);

const select_eVoucherDetails = () => createSelector(
  selectMyEGiftCardsDomain,
  (MyEGiftCards) => utils.immutableToJS(MyEGiftCards.get('eVoucherDetails')),
);
const select_isBoolean = (key) => createSelector(
  selectMyEGiftCardsDomain,
  (MyEGiftCards) => MyEGiftCards.get(key),
);
const select_eVoucherJS = (key) => createSelector(
  selectMyEGiftCardsDomain,
  (MyEGiftCards) => utils.immutableToJS(MyEGiftCards.get(key)),
);
export { selectMyEGiftCards, select_eVoucherDetails, select_isBoolean, select_eVoucherJS };



// WEBPACK FOOTER //
// client/containers/MyEGiftCards/selectors.js